import React from 'react'
import superagent from 'superagent'
import {
    getCurrentMedia,
    getCurrentMediaArkName,
} from 'redux/currentMedia/selectors'
import { getServerUrl } from 'redux/configuration/selectors'
import {
    addSuccessAlert,
    addErrorAlert,
} from 'redux/notifications/actions'
import { isCurrentMediaBookmarked } from 'redux/bookmarks/selectors'

import SuccessMessage from 'components/Visualizer/Notifications/Alerts/Bookmark/SuccessMessage.jsx'

export const INIT_BOOKMARKS = 'INIT_BOOKMARKS'
export const initBookmarks = (bookmarks) => ({
    type: INIT_BOOKMARKS,
    bookmarks,
})

export const ADD_BOOKMARK = 'ADD_BOOKMARK'
export const addBookmark = (media) => ({
    type: ADD_BOOKMARK,
    media,
})

export const REMOVE_BOOKMARK = 'REMOVE_BOOKMARK'
export const removeBookmark = (media) => ({
    type: REMOVE_BOOKMARK,
    media,
})

export function toggleBookmark() {
    return async function toggleBookmark(dispatch, getState) {
        const currentState = getState()
        const media = getCurrentMedia(currentState)
        const arkName = getCurrentMediaArkName(currentState)
        const serverUrl = getServerUrl(currentState)

        //FIXME these URLs should not be hard coded. Retrieved from context ? https://github.com/naoned/kenao/issues/2250
        const url = `${serverUrl}/user/api/v1/bookmark/media/${arkName}/${media.uuid}`
        const bookmarkListUrl = `${serverUrl}/user/bookmarks`
        const alreadyBookmarked = isCurrentMediaBookmarked(currentState)

        let httpRequest = superagent
            .post(url)

        if(alreadyBookmarked) {
            httpRequest = superagent
                .delete(url)
        }

        await httpRequest
        .then((res) => {
            if (res.ok)
            {
                let message = 'visualizer:toolbar.left.bookmark.remove.success'
                if(! alreadyBookmarked)
                {
                    message = <SuccessMessage link={bookmarkListUrl} />
                    dispatch(addBookmark(media))
                }
                else
                {
                    dispatch(removeBookmark(media))
                }

                dispatch(addSuccessAlert(message))
            }
        })
        .catch(function(err) {
            let message = 'visualizer:toolbar.left.bookmark.remove.error'
            if(! alreadyBookmarked)
            {
                message = 'visualizer:toolbar.left.bookmark.create.error'
            }

            dispatch(addErrorAlert(message))
        })
    }
}
